import axios from "axios";
import { appId, ticketBaseURL } from "../config/api";

export const getActiveTaxes = () => {
    return getFetch(`tax/GetActiveTaxesByApplicationId/${appId}`)
}

const getFetch = (url: string, params = {}) => {
    return axios({
        url: ticketBaseURL + url,
        method: "GET",
        params: params
    }).then(response => response.data);
}
